import axios from "axios"
import moment from "moment"
import React, { Component } from "react"
import Loader from "src/components/common/Loader"
import EmployeeDataTypes from "src/pages/hr/Types/EmployeeTypes"
import AxiosConfig from "src/utilities/AxiosConfig"
import snackBar from "src/utilities/snackBar/SnackBar"
import ManageDetail from "../../ManageDetail"
import { PTOPlanType, PTOSnapshotType } from "../../types"
import "./PTODecoupler.css"

interface Props {
    EmployeeID: string | number
}

interface State {
    ledgerEntryTypes: { id: number, text: string } | any
    ptoData: any
    timeAdminReference: { states: Array<any>, profitCenters: Array<any>, departments: Array<any>, ptoPlans: Array<PTOPlanType> } | null
    employee: EmployeeDataTypes | null
    error: boolean
}

class PTODecoupler extends Component<Props, State> {

    state = {
        ledgerEntryTypes: [],
        ptoData: null,
        timeAdminReference: null,
        employee: null,
        error: false
    }

    componentDidMount() {
        this.getEmployeeData()
    }

    getEmployeeData = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/user/getSingleUser/" + this.props.EmployeeID, AxiosConfig.configValue())
            .then(res => {
                this.setState({ employee: res.data.users[0] })
            }).then(() => {
                this.getPtOData()
            })
            .catch(err => {
                this.handleError()
                //console.log(err)
            })
    }

    getPtOData = () => {
        if (this.state.employee) {
            const currentYearStart: any = moment(new Date().getFullYear(), "YYYY").valueOf()
            const today = Date.now()
            const employee = this.state.employee
            //@ts-ignore
            let endpoint = `${process.env.REACT_APP_API_URL}/api/pto/ptodata/${employee.HomeProfitCenterId}/${currentYearStart}/${today}/${employee.Inactive}`
            axios.get(endpoint, AxiosConfig.configValue("min"))
                .then((res) => {
                    let ptoData = this.filterOutUser(res.data.data)
                    if (ptoData) {
                        this.setState({ ledgerEntryTypes: res.data.ledgerEntryTypes, ptoData: ptoData })
                    } else {
                        this.handleError()
                    }

                })
                .catch((err) => {
                    this.handleError()
                    //console.log("error", err);
                })
        } else {
            setTimeout(() => {
                this.getPtOData()
            }, 500)
        }
    }

    filterOutUser = (ptoData: Array<PTOSnapshotType>) => {
        const state = this.state
        for (let i = 0; i < ptoData.length; i++) {
            //@ts-ignore
            if (ptoData[i].UserId === state.employee.UserId) {
                return ptoData[i]
            }
        }
        return null
    }

    handleError = () => {
        this.setState({ error: true })
        snackBar({ text: "Error getting employee PTO data", type: "error", timeout: 3000 })
    }

    render() {

        const state = this.state

        const ledgerReference = {
            ledgerEntryTypes: state.ledgerEntryTypes,
            ledgerStatusTypes: []
        }
        const ptoDetails = state.ptoData

        const ready = state.employee && state.ledgerEntryTypes.length > 0 && !state.error

        return (
            <div className="PTODecoupler">
                {ready && <ManageDetail
                    ledgerReference={ledgerReference}
                    reference={state.timeAdminReference}
                    handleClose={() => null}
                    details={ptoDetails}
                    updateTable={() => null}
                    hideHeader={true}
                    toggleVertical={() => null}
                    isVertical={false}
                />}
                {!ready && <div className="PTODecouplerLoading">
                    <span className="material-icons">access_time</span>
                    <Loader title="Loading PTO requests" />
                </div>}
            </div>
        )
    }
}

export default PTODecoupler